import { render, staticRenderFns } from "./DemoFormViews.vue?vue&type=template&id=3ff57646&scoped=true"
import script from "./DemoFormViews.vue?vue&type=script&lang=js"
export * from "./DemoFormViews.vue?vue&type=script&lang=js"
import style0 from "./DemoFormViews.vue?vue&type=style&index=0&id=3ff57646&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff57646",
  null
  
)

export default component.exports